export default "__VITE_ASSET__SjJNl0Mf__"